/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../$$_gendir/node_modules/angular2-spinner/dist/angular2-spinner.ngfactory';
import * as import2 from 'angular2-spinner/dist/angular2-spinner';
import * as import3 from '@angular/common';
import * as import4 from '@angular/router';
import * as import5 from '@ngx-translate/core/src/translate.pipe';
import * as import6 from '@ngx-translate/core/src/translate.service';
import * as import7 from 'ngx-pagination';
import * as import8 from '../../../$$_gendir/node_modules/ngx-pagination/dist/ngx-pagination.ngfactory';
import * as import9 from '../../../app/shared/directives/no-blank.directive';
import * as import10 from '../../../app/pipes/filter-by-keys.pipe';
import * as import11 from '../../../app/pipes/duration.pipe';
import * as import12 from '../../../app/contract/contract-list.component';
import * as import13 from '../../../app/services/contracts.service';
import * as import14 from '../../../app/services/local-storage.service';
import * as import15 from '../../../app/services/company.service';
import * as import16 from 'ng2-breadcrumb/app/components/breadcrumbService';
import * as import17 from '../../../app/services/language.service';
import * as import18 from '../../../app/services/date.service';
const styles_ContractListComponent:any[] = ([] as any[]);
export const RenderType_ContractListComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ContractListComponent,
  data: {}
}
);
function View_ContractListComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'spinner center-v-h'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'spinner-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wczytywanie listy kontraktów'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import1.View_SpinnerComponent_0,import1.RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import2.SpinnerComponent,([] as any[]),{
      size: [
        0,
        'size'
      ]
      ,
      tickness: [
        1,
        'tickness'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_7:any = 35;
    const currVal_8:any = 3;
    ck(v,6,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,6).size;
    const currVal_1:any = import0.ɵnov(v,6).size;
    const currVal_2:any = import0.ɵnov(v,6).tickness;
    const currVal_3:any = import0.ɵnov(v,6).color;
    const currVal_4:any = import0.ɵnov(v,6).secondColor;
    const currVal_5:any = import0.ɵnov(v,6).secondColor;
    const currVal_6:any = import0.ɵnov(v,6).secondColor;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_ContractListComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'empty-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'src',
        '../../assets/images/icons/contract.png'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Brak kontraktów do wyświetlenia'])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(null as any));
}
function View_ContractListComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'spinner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['`\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'spinner-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wczytywanie listy kontraktów'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import1.View_SpinnerComponent_0,import1.RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import2.SpinnerComponent,([] as any[]),{
      size: [
        0,
        'size'
      ]
      ,
      tickness: [
        1,
        'tickness'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    const currVal_7:any = 35;
    const currVal_8:any = 3;
    ck(v,6,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,6).size;
    const currVal_1:any = import0.ɵnov(v,6).size;
    const currVal_2:any = import0.ɵnov(v,6).tickness;
    const currVal_3:any = import0.ɵnov(v,6).color;
    const currVal_4:any = import0.ɵnov(v,6).secondColor;
    const currVal_5:any = import0.ɵnov(v,6).secondColor;
    const currVal_6:any = import0.ɵnov(v,6).secondColor;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_ContractListComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Bezterminowy']))
  ]
  ,(null as any),(null as any));
}
function View_ContractListComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵppd(3)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,ck(v,2,0,import0.ɵnov((<any>(<any>(<any>(<any>v.parent).parent).parent).parent),2),(<any>v.parent).context.$implicit.duration,(<any>v.parent).context.$implicit.duration,co.languageService.getLanguage()));
    ck(v,1,0,currVal_0);
  });
}
function View_ContractListComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),21,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵppd(2),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractListComponent_7)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractListComponent_8)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,17).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import4.RouterLinkWithHref,[
      import4.Router,
      import4.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵpad(2),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    const currVal_2:any = v.context.$implicit.perpetual;
    ck(v,10,0,currVal_2);
    const currVal_3:boolean = !v.context.$implicit.perpetual;
    ck(v,13,0,currVal_3);
    const currVal_6:any = ck(v,18,0,'/contracts/details/',v.context.$implicit.id);
    ck(v,17,0,currVal_6);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = v.context.$implicit.name;
    ck(v,3,0,currVal_0);
    const currVal_1:any = (v.context.$implicit.agreement_end? import0.ɵunv(v,6,0,ck(v,7,0,import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),1),co.dateService.formatDate(v.context.$implicit.agreement_end),'dd.MM.yyyy')): '-');
    ck(v,6,0,currVal_1);
    const currVal_4:any = import0.ɵnov(v,17).target;
    const currVal_5:any = import0.ɵnov(v,17).href;
    ck(v,16,0,currVal_4,currVal_5);
    const currVal_7:any = import0.ɵunv(v,19,0,import0.ɵnov(v,20).transform('GENERAL.DETAILS'));
    ck(v,19,0,currVal_7);
  });
}
function View_ContractListComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),38,'div',[[
        'class',
        'table-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),32,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Nazwa kontraktu'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Termin wygaśnięcia'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Okres trwania'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Akcje'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),11,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractListComponent_5)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),5,(null as any),View_ContractListComponent_6)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import0.ɵpad(1),
    import0.ɵppd(3),
    import0.ɵpod([
      'itemsPerPage',
      'currentPage'
    ]
    ),
    import0.ɵpid(0,import7.PaginatePipe,[import7.PaginationService]),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'pagination-controls',[
      [
        'directionLinks',
        'true'
      ]
      ,
      [
        'nextLabel',
        'Następne'
      ]
      ,
      [
        'previousLabel',
        'Poprzednie'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'pageChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pageChange' === en)) {
        const pd_0:any = ((<any>(co.p = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_PaginationControlsComponent_0,import8.RenderType_PaginationControlsComponent)),
    import0.ɵdid(49152,(null as any),0,import7.PaginationControlsComponent,([] as any[]),{
      directionLinks: [
        0,
        'directionLinks'
      ]
      ,
      previousLabel: [
        1,
        'previousLabel'
      ]
      ,
      nextLabel: [
        2,
        'nextLabel'
      ]

    }
    ,{pageChange: 'pageChange'}),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.contractsLoading;
    ck(v,25,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,28,0,import0.ɵnov(v,32).transform(import0.ɵunv(v,28,0,ck(v,30,0,import0.ɵnov((<any>(<any>v.parent).parent),0),co.contracts,ck(v,29,0,'name'),co.contractNameValue)),ck(v,31,0,10,co.p)));
    ck(v,28,0,currVal_1);
    const currVal_2:any = 'true';
    const currVal_3:any = 'Poprzednie';
    const currVal_4:any = 'Następne';
    ck(v,37,0,currVal_2,currVal_3,currVal_4);
  },(null as any));
}
function View_ContractListComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),28,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),15,'header',[[
        'class',
        'blocks header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'h2',[[
        'class',
        'section-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'class',
        'wider search'
      ]
      ,
      [
        'type',
        'search'
      ]

    ]
    ,[
      [
        8,
        'value',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('keyup' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,14).inputChanged($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('input' === en)) {
        const pd_1:any = ((<any>(co.contractNameValue = $event.target.value)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import9.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'bar blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractListComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractListComponent_4)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:boolean = !co.contracts.length;
    ck(v,24,0,currVal_3);
    const currVal_4:any = co.contracts.length;
    ck(v,27,0,currVal_4);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,7,0,import0.ɵnov(v,8).transform('CONTRACTS.CONTRACTS'));
    ck(v,7,0,currVal_0);
    const currVal_1:any = co.contractNameValue;
    const currVal_2:any = import0.ɵinlineInterpolate(1,'',import0.ɵunv(v,13,1,import0.ɵnov(v,15).transform('GENERAL.SEARCH')),'');
    ck(v,13,0,currVal_1,currVal_2);
  });
}
export function View_ContractListComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import10.FilterByKeysPipe,([] as any[])),
    import0.ɵpid(0,import3.DatePipe,[import0.LOCALE_ID]),
    import0.ɵpid(0,import11.DurationPipe,([] as any[])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractListComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ContractListComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n']))
  ]
  ,(ck,v) => {
    var co:import12.ContractListComponent = v.component;
    const currVal_0:any = co.contractsListLoading;
    ck(v,4,0,currVal_0);
    const currVal_1:boolean = !co.contractsListLoading;
    ck(v,7,0,currVal_1);
  },(null as any));
}
function View_ContractListComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-contract-list',([] as any[]),(null as any),(null as any),(null as any),View_ContractListComponent_0,RenderType_ContractListComponent)),
    import0.ɵdid(4308992,(null as any),0,import12.ContractListComponent,[
      import13.ContractsService,
      import14.LocalStorageService,
      import15.CompanyService,
      import16.BreadcrumbService,
      import17.LanguageService,
      import18.DateService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ContractListComponentNgFactory:import0.ComponentFactory<import12.ContractListComponent> = import0.ɵccf('app-contract-list',import12.ContractListComponent,View_ContractListComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/contract/contract-list.component.ngfactory.ts